export default __webpack_public_path__ + "static/media/ibank-logo-green.21c7e06c.png";